import { Star } from "lucide-react";
import { formatDate } from "@/lib/api";
import { SectionHead } from "@/components/site/InfoSections";
import { ReviewDialog } from "@/components/site/ReviewDialog";

export const Stars = ({ value, size = "h-4 w-4" }) => (
  <span className="inline-flex gap-0.5" aria-label={`${value} out of 5 stars`}>
    {[1, 2, 3, 4, 5].map((n) => (
      <Star key={n} className={`${size} ${n <= value ? "fill-[#FFD23F] text-[#FFD23F]" : "text-zinc-600"}`} />
    ))}
  </span>
);

export const ReviewsSection = ({ reviews, summary, onChanged }) => (
  <section id="reviews" className="section-anchor relative bg-[#1A1A1E]" data-testid="reviews-section">
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 sm:py-24">
      <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
        <SectionHead eyebrow="Word around town" title="Reviews">
          {summary.count > 0 && (
            <p className="font-display mt-4 text-3xl text-[#FFD23F]" data-testid="reviews-summary">
              {summary.average.toFixed(1)} ★ from {summary.count} {summary.count === 1 ? "review" : "reviews"}
            </p>
          )}
        </SectionHead>
        {reviews.length > 0 && <div className="mb-10 sm:mb-14"><ReviewDialog onPublished={onChanged} /></div>}
      </div>
      {reviews.length === 0 ? (
        <div className="flex flex-col items-center gap-6 rounded-md border border-dashed border-zinc-700 p-10 text-center" data-testid="reviews-empty">
          <p className="text-lg text-zinc-300">No reviews yet — be the first to share your experience.</p>
          <ReviewDialog onPublished={onChanged} />
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {reviews.map((r) => (
            <article key={r.id} className="flex flex-col rounded-md border border-zinc-800 bg-[#121214] p-6" data-testid={`review-card-${r.id}`}>
              <Stars value={r.rating} />
              <p className="mt-4 flex-1 whitespace-pre-line break-words text-base leading-relaxed text-zinc-200" data-testid="review-text">“{r.text}”</p>
              <div className="mt-6 border-t border-zinc-800 pt-4">
                <p className="font-sub break-words font-semibold uppercase tracking-wide text-[#FAF7F2]" data-testid="review-name">{r.name}</p>
                <p className="mt-0.5 text-sm text-zinc-400">
                  {r.vehicle && <span data-testid="review-vehicle">{r.vehicle} · </span>}
                  <span data-testid="review-date">{formatDate(r.date)}</span>
                </p>
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  </section>
);
